import { useState, useEffect } from 'react';
import { getApiBaseUrl } from '../../../../core/config/api';

export interface MaintenanceStatus {
  enabled: boolean;
  message: string | null;
  scheduled_at: string | null;
  scheduled_message: string | null;
}

export function useMaintenanceStatus() {
  const [maintenanceStatus, setMaintenanceStatus] = useState<MaintenanceStatus | null>(null);

  useEffect(() => {
    const check = async () => {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 2000);
        const response = await fetch(`${getApiBaseUrl(true)}/admin/maintenance/status`, {
          signal: controller.signal,
        });
        clearTimeout(timeoutId);
        if (!response.ok) return;
        const data = await response.json().catch(() => ({}));
        if (data?.success && data?.data) {
          setMaintenanceStatus({
            enabled: data.data.enabled === 1 || data.data.enabled === true,
            message: data.data.message || null,
            scheduled_at: data.data.scheduled_at || null,
            scheduled_message: data.data.scheduled_message || null,
          });
        }
      } catch (error: any) {
        if (error?.name !== 'AbortError') {
          console.debug('Maintenance status check failed on map:', error);
        }
      }
    };

    void check();
    const id = window.setInterval(check, 30000);
    return () => window.clearInterval(id);
  }, []);

  return { maintenanceStatus };
}
